// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import HotSpring from '../_raw/service/icon_hot_spring.svg';
import withIconProps from '../withIconProps';

export default withIconProps(HotSpring);
